<script setup lang="ts">
import HugeIcon from '../HugeIcon/HugeIcon.vue';
import { ref } from 'vue';

const props = defineProps<{
  placeholder?: string;
  expandable?: boolean;
}>();

const value = defineModel<string>({ default: '' });
const expanded = ref(!props.expandable);
const inputRef = ref<HTMLInputElement | null>(null);

const expand = () => {
  expanded.value = true;
  inputRef.value?.focus();
};

const collapse = () => {
  value.value = '';
  expanded.value = false;
};
</script>

<template>
  <div
    class="focus-highlight transition-duration-150 flex h-[34px] items-center rounded-lg border bg-white text-neutral-500 transition-all ease-out"
    :class="[
      !props.expandable || expanded
        ? 'border-slate-200'
        : 'cursor-pointer justify-center overflow-hidden border-none hover:bg-slate-50',
    ]"
    @click="expand"
  >
    <HugeIcon
      :class="[!props.expandable || expanded ? 'mx-2' : 'mx-0 w-[34px]']"
      icon="search"
    />
    <input
      ref="inputRef"
      v-model="value"
      :placeholder="props.placeholder"
      class="flex-1 text-black transition-all duration-150 ease-out"
      :class="[
        !props.expandable || expanded
          ? 'w-[200px] opacity-100'
          : 'w-0 opacity-0',
      ]"
      type="text"
    />
    <button
      class="overflow-hidden transition-all duration-150 ease-out hover:text-black"
      :class="[
        !props.expandable || expanded
          ? 'mx-2 opacity-100'
          : 'mx-0 w-0 opacity-0',
      ]"
      @click.stop="collapse"
    >
      <HugeIcon icon="cancel" />
    </button>
  </div>
</template>
